import { render, staticRenderFns } from "./TimeToMarketPage.vue?vue&type=template&id=9098fc56&"
import script from "./TimeToMarketPage.vue?vue&type=script&lang=js&"
export * from "./TimeToMarketPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports